import { render, staticRenderFns } from "./CoreItemFour.vue?vue&type=template&id=bbf378aa&scoped=true"
import script from "./CoreItemFour.vue?vue&type=script&lang=js"
export * from "./CoreItemFour.vue?vue&type=script&lang=js"
import style0 from "./CoreItemFour.vue?vue&type=style&index=0&id=bbf378aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf378aa",
  null
  
)

export default component.exports